/**
 * en-GB messages added by Phase 2 task W14 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w14EnGB = {
    // Member tab
    'peo.member.title': 'CloudSign app',
    'peo.member.description': 'Invite this person to the CloudSign app on their phone, or show a QR code for them to scan.',
    'peo.member.pageHelp': 'The CloudSign app on this person’s phone.',
    'peo.member.invite': 'Send invite',
    'peo.member.showQr': 'Show QR',
    'peo.member.noEmail': 'This person has no email address, so the invite can only be shown as a QR code.',
    'peo.member.inviteSent': 'Invite sent.',
    'peo.member.revoked': 'Phone signed out of the app.',
    'peo.member.qrAlt': 'QR code that links this person’s phone to the CloudSign app',
    'peo.member.qrHelp': 'Ask them to scan this with their phone camera. It works once and expires.',
    'peo.devices.title': 'Phones',
    'peo.devices.empty': 'No phones are linked yet.',
    'peo.devices.name': 'Phone',
    'peo.devices.lastSeen': 'Last seen',
    'peo.devices.state': 'Settings',
    'peo.devices.never': 'Never',
    'peo.devices.pushOn': 'Notifications on',
    'peo.devices.pushOff': 'Notifications off',
    'peo.devices.locationOn': 'Location allowed',
    'peo.devices.locationOff': 'Location not allowed',
    'peo.devices.lockOn': 'App lock set',
    'peo.devices.lockOff': 'No app lock',
    'peo.devices.revoke': 'Sign out phone',
    'peo.devices.revokeConfirm': 'Yes, sign out',
    // Group card
    'peo.group.title': 'Companion app',
    'peo.group.description': 'Lets people in this group sign in and out from their own phone.',
    'peo.group.enabled': 'Allow the Companion app for this group',
    'peo.group.enabledHelp': 'Off by default. People still need an invite before they can use it.',
    'peo.group.permissions': 'What the app may do',
    'peo.group.appLock': 'Require a screen lock on the phone',
    'peo.group.appLockHelp': 'The app asks for the phone’s PIN, pattern or fingerprint each time it opens.',
    'peo.group.selfInvite': 'Let people ask for their own invite at the kiosk',
    'peo.group.selfInviteHelp': 'Sends the invite to the email address held for them.',
    'peo.group.inviteAll': 'Invite everyone',
    'peo.group.saveFirst': 'Save your changes before inviting.',
    'peo.group.invited': 'Invites sent: {sent}.',
    'peo.group.inviteResult': 'Invites sent: {sent}. Skipped because there is no email address: {skipped}.',
    'peo.perm.mobileSignIn': 'Sign in and out from the phone',
    'peo.perm.mobileSignIn.help': 'A button in the app.',
    'peo.perm.locationSignIn': 'Sign in automatically on arrival',
    'peo.perm.locationSignIn.help': 'Uses the phone’s location near a site. Each person must agree on their phone first.',
    'peo.perm.preRegister': 'Pre-register visitors',
    'peo.perm.preRegister.help': 'They become the host of the visitors they add.',
    'peo.perm.ownHistory': 'See their own sign-in history',
    'peo.perm.ownHistory.help': 'Only their own visits.',
    'peo.perm.todayView': 'See who is in today',
    'peo.perm.todayView.help': 'Names only, for the sites they can see.',
    'peo.perm.evacuationList': 'See the evacuation list',
    'peo.perm.evacuationList.help': 'Available when the evacuation feature arrives.',
    // API clients
    'peo.tab.clients': 'API clients',
    'peo.tab.matching': 'Needs matching',
    'peo.clients.title': 'API clients',
    'peo.clients.description': 'Keys that let other systems talk to CloudSign, limited to the calls, sites and groups you choose.',
    'peo.clients.add': 'New API client',
    'peo.clients.name': 'Name',
    'peo.clients.scopes': 'Allowed calls',
    'peo.clients.sites': 'Sites',
    'peo.clients.allSites': 'All sites',
    'peo.clients.noSites': 'No sites',
    'peo.clients.lastUsed': 'Last used',
    'peo.clients.never': 'Never',
    'peo.clients.system': 'System: {system}',
    'peo.clients.managed': 'Managed by an integration. Change it on that integration’s page.',
    'peo.clients.active': 'Active',
    'peo.clients.revokedState': 'Revoked',
    'peo.clients.newKey': 'New key',
    'peo.clients.newKeyConfirm': 'Yes, replace the key',
    'peo.clients.revoke': 'Revoke',
    'peo.clients.revokeConfirm': 'Yes, revoke',
    'peo.clients.revoked': 'API client revoked.',
    'peo.clients.secret.created': 'API key created',
    'peo.clients.secret.rotated': 'New API key',
    'peo.clients.secret.description': 'Give this key to the other system. The old key, if any, stops working now.',
    'peo.clients.secret.label': 'API key',
    'peo.clients.create.title': 'New API client',
    'peo.clients.create.submit': 'Create client',
    'peo.clients.create.name': 'Name',
    'peo.clients.create.system': 'System name (optional)',
    'peo.clients.create.systemHelp': 'Lowercase letters, numbers, - or _. Used to match people from that system.',
    'peo.clients.create.scopes': 'What it may do',
    'peo.clients.create.sites': 'Which sites it may use',
    'peo.clients.create.groups': 'Which groups it may sign in',
    'peo.clients.create.groupsHelp': 'People are matched only inside the groups you tick. With none ticked it cannot match anyone.',
    'peo.clients.create.defaultGroup': 'Group for people it does not place',
    'peo.clients.create.defaultGroupHelp': 'Used when a sign-in does not name a group.',
    'peo.clients.create.noDefault': 'None',
    'peo.scope.visits.sign_in': 'Sign people in',
    'peo.scope.visits.sign_in.help': 'Record a sign-in from the other system.',
    'peo.scope.visits.sign_out': 'Sign people out',
    'peo.scope.visits.sign_out.help': 'Record a sign-out from the other system.',
    'peo.scope.visits.on_site': 'See who is on site',
    'peo.scope.visits.on_site.help': 'Lets the other system catch up after an outage.',
    'peo.scope.webhooks.test': 'Send test messages',
    'peo.scope.webhooks.test.help': 'Lets the other system check that messages arrive.',
    // Needs matching
    'peo.match.system': 'System',
    'peo.match.noSystems': 'No systems are connected yet. Create an API client with a system name first.',
    'peo.match.help': 'These people were sent by another system and could not be matched safely. Nothing is guessed: choose what to do with each one.',
    'peo.match.empty': 'Everyone has been matched.',
    'peo.match.externalId': 'Their id there: {id}',
    'peo.match.seen': 'Last seen {when}, {count} tries',
    'peo.match.resolve': 'Resolve',
    'peo.match.dismiss': 'Dismiss',
    'peo.match.dismissConfirm': 'Yes, dismiss',
    'peo.match.link': 'Link to a member',
    'peo.match.create': 'Create a member',
    'peo.match.group': 'Group',
    'peo.match.noGroups': 'There is no group of members to choose from yet.',
    'peo.match.search': 'Search members',
    'peo.match.noMembers': 'No members found.',
    'peo.match.linkButton': 'Link',
    'peo.match.linkTo': 'Link to {name}',
    'peo.match.createButton': 'Create {name} in this group',
    'peo.match.resolved': 'Done.',
    // Link to the Oakford Mobile Portal (only shown once the module is switched on)
    'peo.omp.off.title': 'Integration',
    'peo.omp.off.body': 'This feature is switched off for your organisation.',
    'peo.omp.title': 'Oakford Mobile Portal',
    'peo.omp.description': 'Keeps sign-ins and sign-outs the same in both systems for linked sites.',
    'peo.omp.connect.title': 'Connect',
    'peo.omp.connect.description': 'CloudSign creates an API key and a webhook secret. They are shown once, so have somewhere ready to store them.',
    'peo.omp.connect.url': 'Address to send messages to',
    'peo.omp.connect.urlHelp': 'The web address the other system gave you for CloudSign messages.',
    'peo.omp.connect.urlBad': 'Enter a full web address starting with https://.',
    'peo.omp.connect.email': 'Alert email address (optional)',
    'peo.omp.connect.emailHelp': 'Told if the other system cannot be reached for 10 minutes. Empty means your organisation’s admin contact.',
    'peo.omp.connect.emailBad': 'Enter a valid email address.',
    'peo.omp.connect.group': 'Group for people signed in from there',
    'peo.omp.connect.groupHelp': 'Usually your staff group.',
    'peo.omp.connect.submit': 'Connect',
    'peo.omp.secret.keyTitle': 'API key',
    'peo.omp.secret.keyLabel': 'API key',
    'peo.omp.secret.webhookTitle': 'Webhook secret',
    'peo.omp.secret.webhookLabel': 'Webhook secret',
    'peo.omp.secret.description': 'Give this to the other system. It cannot be shown again.',
    'peo.omp.status.title': 'Status',
    'peo.omp.webhook.active': 'Messages are flowing',
    'peo.omp.webhook.paused': 'Paused',
    'peo.omp.webhook.failing': 'Cannot reach the other system',
    'peo.omp.failingSince': 'Failing since {when}',
    'peo.omp.never': 'Never',
    'peo.omp.status.lastOut': 'Last message sent',
    'peo.omp.status.lastIn': 'Last message received',
    'peo.omp.status.key': 'API key id',
    'peo.omp.status.sites': 'Linked sites',
    'peo.omp.status.people': 'Linked people',
    'peo.omp.status.unmatched': 'People needing a match',
    'peo.omp.matchLink': 'Match {count} people',
    'peo.omp.test': 'Test connection',
    'peo.omp.test.ok': 'The other system answered in {ms} ms.',
    'peo.omp.test.failed': 'The other system did not accept the test (code {code}).',
    'peo.omp.rotateKey': 'New API key',
    'peo.omp.rotateSecret': 'New webhook secret',
    'peo.omp.rotateConfirm': 'Yes, replace it',
    'peo.omp.disconnect': 'Disconnect',
    'peo.omp.disconnectConfirm': 'Yes, disconnect',
    'peo.omp.disconnected': 'Disconnected. Site and people links are kept.',
    'peo.omp.sites.title': 'Site links',
    'peo.omp.sites.description': 'Only sites with an office id are shared. Leave it empty to stop sharing a site.',
    'peo.omp.sites.site': 'CloudSign site',
    'peo.omp.sites.office': 'Office id in the other system',
    'peo.omp.sites.officeFor': 'Office id for {name}',
    'peo.omp.messages.title': 'Latest messages',
    'peo.omp.messages.description': 'The last 100 messages in each direction.',
    'peo.omp.messages.empty': 'No messages yet.',
    'peo.omp.messages.when': 'When',
    'peo.omp.messages.direction': 'Direction',
    'peo.omp.messages.what': 'What',
    'peo.omp.direction.outbound': 'Sent',
    'peo.omp.direction.inbound': 'Received',
};
//# sourceMappingURL=w14.js.map